/**
 * Returns true when quality-forms is nested under another iframe (e.g. WD →
 * PDUI → quality-forms) and list↔editor transitions should ask the host to
 * navigate instead of using in-app react-router.
 *
 * Detection: only request host navigation when we are in a *nested* iframe
 * (`parent !== top`). A direct iframe under web-directory (`parent === top`)
 * and top-level windows (local standalone) use react-router.
 */
export function shouldRequestHostNavigation(
    win: Pick<Window, "self" | "top" | "parent"> = window
): boolean {
    if (win.self === win.top) {
        return false;
    }
    // Nested under another iframe (PDUI inside WD). Comparing Window references
    // does not require reading cross-origin properties.
    return win.parent !== win.top;
}
